import { motion } from 'framer-motion'
import getConfig from 'next/config'

import { sprinkles } from '@/design-lib/style-theme/sprinkles.css'

import { planimetryModalMotionDiv } from './styles.css'

type ModalPlanimetryProps = {
  url: string
}

export const ModalPlanimetry = ({ url }: ModalPlanimetryProps) => {
  const {
    publicRuntimeConfig: { imgixDefaultOptions },
  } = getConfig()

  return (
    <motion.div animate={{ opacity: 1 }} className={planimetryModalMotionDiv} initial={{ opacity: 0 }}>
      {/* TODO should we use Next/Image here? */}
      <img
        alt="planimetry"
        className={sprinkles({
          maxHeight: '100%',
        })}
        src={url + '?' + imgixDefaultOptions}
      />
    </motion.div>
  )
}
